<template>
  <base-dialog
    :title="'Archive Product'"
    :action="onAction"
    :action-name="'Archive'"
    :close="onClose"
  >
    <template #activator="{ on }">
      <slot
        name="activator"
        v-bind="{ on }"
      />
    </template>

    <template #content>
      <div>
        <p>
          <b>Are you sure you want to archive this product?</b>
        </p>
      </div>
    </template>
  </base-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import BaseDialog from "../Common/BaseDialog"

export default {
  components: {
    BaseDialog
  },
  props: {
    id: {
      type: String,
      required: true,
    }
  },
  methods: {
    ...mapActions([ 'updateProductAndVariants' ]),
    async onAction() {
      const payload = {
        id: this.id,
        isArchived: true
      }
      await this.updateProductAndVariants(payload)
    },
    async onClose() {

    }
  }
}
</script>
